import React from 'react';
import { Descriptions } from 'antd';
import { DescriptionsItemProps as DescriptionsItemCopyProps } from 'antd/lib/descriptions/Item';

export type DescriptionsItemProps = DescriptionsItemCopyProps;

const ProDescriptionsItem: React.FC<DescriptionsItemProps> = (props) => {
  const { children, ...resProps } = props;

  return <Descriptions.Item {...resProps}>{children}</Descriptions.Item>;
};

export default ProDescriptionsItem;
